import { render, staticRenderFns } from "./NotifyTalants.vue?vue&type=template&id=363c85bb"
import script from "./NotifyTalants.vue?vue&type=script&lang=js"
export * from "./NotifyTalants.vue?vue&type=script&lang=js"
import style0 from "./NotifyTalants.vue?vue&type=style&index=0&id=363c85bb&prod&lang=css"
import style1 from "./NotifyTalants.vue?vue&type=style&index=1&id=363c85bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports